import React from 'react';
import './Pagination.css'; // for styling
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { IconButton, FormControl, Select, MenuItem } from '@mui/material';

const PaginationFooter = ({
  totalRecords,
  currentPage,
  itemsPerPage,
  setCurrentPage,
  setItemsPerPage,
}) => {
  const totalPages = Math.ceil(totalRecords / itemsPerPage);
  const itemsPerPageOptions = [50, 100, 150, 200];

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleItemsPerPageChange = (event) => {
    const newItemsPerPage = parseInt(event.target.value);
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1); // Reset to first page when changing items per page
  };

  // if (totalPages === 0) return null;

  return (
    <div className="pagination-footer">
      <div className="pagination-container">
        <div className="total-records">
          Total Records: <strong>{totalRecords}</strong>
        </div>
        <div className="pagination-controls">
          <FormControl size="small" className="items-per-page-control d-flex justify-content-center align-items-center">
            <div>
              <span className="per-page-label">Per Page:</span>
            </div>
            <div>
              <Select
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
                displayEmpty
                className="items-per-page-select"
              >
                {itemsPerPageOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </FormControl>
          <IconButton
            className="pagination-text-btn"
            disabled={currentPage === 1}
            onClick={() => goToPage(currentPage - 1)}
          >
            <NavigateBeforeIcon />
          </IconButton>
          <span className="page-info">
            Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
          </span>
          <IconButton
            className="pagination-text-btn"
            disabled={currentPage === totalPages}
            onClick={() => goToPage(currentPage + 1)}
          >
            <NavigateNextIcon />
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default PaginationFooter;
